import React from 'react';
const PremiumGallery40 = ({ className })=>/*#__PURE__*/ React.createElement("svg", {
        className: className,
        width: "16",
        height: "16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M14 1H3V2.5H13.1C13.3209 2.5 13.5 2.67909 13.5 2.9V13H15V2C15 1.44772 14.5523 1 14 1Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1 5C1 4.44772 1.44772 4 2 4H11C11.5523 4 12 4.44772 12 5V14C12 14.5523 11.5523 15 11 15H2C1.44771 15 1 14.5523 1 14V5ZM9.28737 7.70295L8.03603 7.05206C7.88481 6.9734 7.69515 6.98466 7.55697 7.0805L6.5 7.81355L5.44303 7.0805C5.30485 6.98466 5.11519 6.9734 4.96397 7.05206L3.71263 7.70295C3.58096 7.77144 3.5 7.89713 3.5 8.03305V9.72255C3.5 9.83171 3.55235 9.93566 3.64384 10.0082L6.21527 12.0463C6.37765 12.175 6.62235 12.175 6.78473 12.0463L9.35616 10.0082C9.44765 9.93566 9.5 9.83171 9.5 9.72255V8.03305C9.5 7.89713 9.41904 7.77144 9.28737 7.70295Z",
        fill: "currentColor"
    }));
PremiumGallery40.displayName = 'PremiumGallery40';
export default PremiumGallery40;
